import React from 'react'
import Layout from '../components/Layout'
import { Helmet } from 'react-helmet'

const NewsLetter = () => {
  const APP_NAME = 'DevsrcBlog'

  const handleSubmit = e => {
    e.preventDefault()
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>NewsLetter | {APP_NAME}</title>
        <meta
          name="description"
          content="Programming blogs and tutorials on react node next vue php laravel and web developoment"
        />
        <link
          rel="canonical"
          href="https://mdx-blog-testing-mode.netlify.app/newsletter"
        />
        <meta
          property="og:title"
          content={`Latest web developoment tutorials | ${APP_NAME}`}
        />
        <meta
          property="og:description"
          content="Programming blogs and tutorials on react node next vue php laravel and web developoment"
        />
        <meta property="og:type" content="webiste" />
        <meta
          property="og:url"
          content="https://mdx-blog-testing-mode.netlify.app/newsletter"
        />
        <meta property="og:site_name" content={`${APP_NAME}`} />

        <meta
          property="og:image"
          content={`https://mdx-blog-testing-mode.netlify.app/newsletter/static/mainImg.png`}
        />
        <meta
          property="og:image:secure_url"
          content={`https://mdx-blog-testing-mode.netlify.app/newsletter/static/mainImg.png/static/mainImg.png`}
        />
        <meta property="og:image:type" content="image/jpg" />
      </Helmet>

      <Layout>
        <section className="newsletter-page">
          <div className="page-center">
            <h2>Get all the latest stories to your inbox</h2>
            <h4>I write to my friends every few weeks</h4>
            <form
              onSubmit={handleSubmit}
              className="contact-form"
              name="contact"
              method="post"
              netlify-honeypot="bot-field"
              data-netlify="true"
              action="/success"
            >
              <input type="hidden" name="bot-field" />
              <input type="hidden" name="form-name" value="contact" />

              <input
                type="text"
                name="name"
                placeholder="Your name"
                className="form-control"
                style={{ marginRight: '6px' }}
              />
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Your email"
                required
                style={{ marginRight: '6px' }}
              />
              <button type="submit" className="btn form-control submit-btn">
                subscribe
              </button>
            </form>
          </div>
        </section>
      </Layout>
    </React.Fragment>
  )
}

export default NewsLetter
